import React from "react";
import styled from "@emotion/styled";
import Spinner from "./Spinner";
import type { SpinnerSize } from "./Spinner";
import { opacity, zIndex as zIndexTokens } from "@atlas-int/tokens";

export interface LoadingOverlayProps {
  visible: boolean;
  /** Screen-reader-only message */
  message?: string;
  size?: SpinnerSize;
  zIndex?: number;
  className?: string;
}

const Overlay = styled.div<{ $zIndex: number }>`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--sem-surface-page);
  opacity: ${opacity.loading};
  z-index: ${({ $zIndex }) => $zIndex};
  pointer-events: auto;
`;

const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

const LoadingOverlay = React.memo<LoadingOverlayProps>(
  ({
    visible,
    message = "Loading...",
    size = "md",
    zIndex = zIndexTokens.above,
    className,
  }) => {
    if (!visible) return null;

    return (
      <Overlay
        $zIndex={zIndex}
        className={className}
        onMouseMove={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Spinner size={size} />
        <SrOnly>{message}</SrOnly>
      </Overlay>
    );
  },
);

LoadingOverlay.displayName = "LoadingOverlay";

export default LoadingOverlay;
